<template>
  <van-overlay :show="visible" z-index="9999">
    <div class="popup-overlay">
      <div class="popup-container">
        <div class="popup-header">
          <span>{{ title }}</span>
        </div>
        <!-- 
          解决移动端内容溢出无法滚动的问题： 
          1. 增加 -webkit-overflow-scrolling: touch;
          2. 增加 touch-action: pan-y;
          3. 容器不要有 display: flex，父级和 popup-content 不嵌套跨度 layout。
        -->
        <div
          class="popup-content"
          @touchmove.stop
        >
          <!-- 使用插槽来渲染自定义内容 -->
          <slot name="content">
            <!-- 默认内容 -->
            <div>{{ content }}</div>
          </slot>
        </div>
        <div class="popup-footer" @click="hidePopup">{{ cancelButtonText }}</div>
      </div>
      <van-icon name="close" size="26px" color="#EDC587" @click="hidePopup"/>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    cancelButtonText: {
      type: String,
      required: true
    },
    imageSrc: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped lang="less">
.popup-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.popup-container {
  position: relative;
  width: 690px;
  height: 800px;
  margin-bottom: 30px;
  background-image: url('@/assets/member/c_popup.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.popup-header {
  position: absolute;
  top: 95px;
  left: 40px;
  color: #EDC587;
  font-size: 35px;
  font-weight: bold;
  color: #000000;
}

.popup-content {
  position: absolute;
  width: 610px;
  height: 400px;
  top: 220px;
  left: 40px;
  text-align: left;
  margin-bottom: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; // 支持弹性滚动
  touch-action: pan-y; // 支持纵向滑动
  /* 兼容性写法（已开启注释） */
  // -webkit-overflow-scrolling: touch;
  // touch-action: pan-y;
}

.popup-footer {
  position: absolute;
  bottom: 30px;
  left: 50%;
  width: 100%;
  height: 100px;
  line-height: 100px;
  transform: translateX(-50%);
  text-align: center;
  font-size: 30px;
  color: #000000;
  cursor: pointer;
}
</style>
